import type { ButtonHTMLAttributes } from "react";
import estilos from "./Boton.module.css";

export type VarianteBoton = "secundario" | "principal" | "fantasma" | "enlace";

export interface PropsBoton extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variante?: VarianteBoton;
  readonly chico?: boolean;
}

/** Botón del portal. Por omisión es `type="button"` para que nunca envíe un formulario sin querer. */
export function Boton({ variante = "secundario", chico = false, className, type = "button", ...resto }: PropsBoton) {
  const clases = [estilos.boton, variante !== "secundario" && estilos[variante], chico && estilos.chico, className]
    .filter(Boolean)
    .join(" ");
  return <button type={type} className={clases} {...resto} />;
}
